import React from "react";
import CategoryOne from "../Category/CategoryOne";

const CategorySection = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-title text-center">
            <span className="subtitle bg-primary-opacity">CATEGORIES</span>
            <h2 className="title">
              Explore Top Caterories <br /> That Change Yourself
            </h2>
          </div>
        </div>
      </div>
      <div className="row g-5 mt--20">
        <CategoryOne />
      </div>
    </div>
  );
};

export default CategorySection;
